<template>
  <p class="text-color-black mb-2">{{ $t('components.Profile.w9warning.whenCompleteForm') }} <a target="_blank" href="https://files.switips.com/legal/merchant/documents/W-9.pdf">{{ $t('components.Profile.w9warning.w9Form') }}</a>.</p>
</template>

<script>
export default {}
</script>
